import { supabase } from '../providers/supabase/client';

export const fetchUpcomingCheckins = async (daysAhead = 7) => {
  const today = new Date();
  const future = new Date();
  future.setDate(today.getDate() + daysAhead);

  const todayStr = today.toISOString().split('T')[0];
  const futureStr = future.toISOString().split('T')[0];

  return await supabase
    .from('upcoming_checkins')
    .select('*')
    .gte('departure_date', todayStr)
    .lte('departure_date', futureStr)
    .order('departure_date', { ascending: true });
};

export const updateCheckinStatus = async (reservationId, status, userId) => {
  const updates = {
    checkin_status: status,
    checkin_completed_by: status === 'COMPLETADO' ? userId : null,
    checkin_completed_at: status === 'COMPLETADO' ? new Date().toISOString() : null,
  };

  return await supabase
    .from('reservations')
    .update(updates)
    .eq('id', reservationId)
    .select('*');
};

/**
 * Call the database function that auto-transitions statuses by date:
 * RESERVADO COMPLETO → EN VIAJE (when departure_date <= today)
 * EN VIAJE → FINALIZADO (when end_date < today)
 * Should be called once per session, not on every render.
 */
export const syncTravelStatuses = async () => {
  return await supabase.rpc('update_travel_statuses');
};
